export * from './lib/instance-dyn.module';
